
export const aksiyonSahibi=[
    {
        text:"SEKILLENDIRME"
    },
    {
        text:"HAMMADDE"
    },
    {
        text:"SIRLAMA"
    },
    {
        text:"DEKORLAMA"
    },
    {
        text:"DIJITAL BASKI"
    },
    {
        text:"DIJITAL LOGO"
    },
    {
        text:"AYAK TASLAMA"
    },
    {
        text:"FIRINLAR"
    },
    {
        text:"KALITE GUVENCE"
    },
]

export const uygunsuzlukTipi=[
    {"text": "Nem"},
    {"text": "Akıntı İzi"},
    {"text": "Arabadaki Ürün Yerleşimi"},
    {"text": "Ayak Çatlağı"},
    {"text": "Ayak Kırığı"},
    {"text": "Ayak Silimi"},
    {"text": "Bant Hızı"},
    {"text": "Bant Hızı Standart Eksikliği"},
    {"text": "Bant Temizliği"},
    {"text": "Basınç Değeri Sınır Dışı"},
    {"text": "Bekleme Süresi"},
    {"text": "Belirlenmiş Alan İhlali"},
    {"text": "Bilgisayar Program Reçetesi"},
    {"text": "Bisküvi Silimi"},
    {"text": "Bomze Seçimi"},
    {"text": "Boya Gramajı"},
    {"text": "Boya Lekesi"},
    {"text": "Cihaz Arızası"},
    {"text": "Çap Değer Uygunsuzluğu"},
    {"text": "Çapak"},
    {"text": "Çatlak"},
    {"text": "Çift Basma"},
    {"text": "Çökme"},
    {"text": "Dalgalanma"},
    {"text": "Deformasyon"},
    {"text": "Deneme Takip Yetersizliği"},
    {"text": "Deneme Üretimi"},
    {"text": "Desen Hatası"},
    {"text": "Devirdaim"},
    {"text": "Dijital Logo Uygulama Hatası"},
    {"text": "Dolum Sorunu"},
    {"text": "Eğitim / Yetkinlik Eksikliği"},
    {"text": "Ekipman Yetersizliği"},
    {"text": "Eksen Farkı"},
    {"text": "Eksenel Çatlak"},
    {"text": "Eldiven Kullanımı"},
    {"text": "Elek"},
    {"text": "Elektrik Kesintisi"},
    {"text": "Etiket Bilgisi"},
    {"text": "Fırın İçi Kurum"},
    {"text": "Gallenkamp değeri"},
    {"text": "Görevlendirme Eksikliği"},
    {"text": "Gramaj"},
    {"text": "Harelenme"},
    {"text": "Hava Boşluğu"},
    {"text": "Hava Kabarcığı"},
    {"text": "Hava Tutma"},
    {"text": "Helezon Lekesi"},
    {"text": "İstif"},
    {"text": "İz Lekesi"},
    {"text": "Kabarma"},
    {"text": "Kalıp Tasarım"},
    {"text": "Kalıp İzi"},
    {"text": "Kalite Ayrım Hatası"},
    {"text": "Karıncalanma"},
    {"text": "Karıştırıcı Uygunsuzluğu"},
    {"text": "Katkı Girme"},
    {"text": "Kayıtların Doğru Girilmemesi"},
    {"text": "Kazan Kapağı Açık"},
    {"text": "Kazan Karışması"},
    {"text": "Kazan Yıkama"},
    {"text": "Kazıma İzi"},
    {"text": "Kenar Bant Hatası"},
    {"text": "Kenar Çatlağı"},
    {"text": "Kenar Ezilmesi"},
    {"text": "Kenar Kırığı"},
    {"text": "Kenar Kopması"},
    {"text": "Kenar Rötuş"},
    {"text": "Kılcal Çatlak"},
    {"text": "Kirli/Uygunsuz Bisküvi"},
    {"text": "Klepe ve Nozul"},
    {"text": "Kulp Açığı"},
    {"text": "Kulp Çatlağı"},
    {"text": "Kulp İçi Çatlak"},
    {"text": "Kulp Kesim Ağzı Yırtılması"},
    {"text": "Kulp Yapıştırma Çamuru Akması"},
    {"text": "Logo Kayması"},
    {"text": "Makine Tanımlama Eksikliği"},
    {"text": "Makine ve Kazan Yıkama"},
    {"text": "Manyetik Temizliği"},
    {"text": "Maşa İzi"},
    {"text": "Membran İzi"},
    {"text": "Merkezleme Hatası"},
    {"text": "Ölçüm yapılmadan üretime başlanması"},
    {"text": "Püskürtme Hattı Ayarı"},
    {"text": "Reçete eksikliği"},
    {"text": "Referans Uyumsuzluğu"},
    {"text": "Renk Skalası Uygunsuzluğu"},
    {"text": "Sertlik Değeri"},
    {"text": "Sıcaklık"},
    {"text": "Sıkıştırma Basıncı"},
    {"text": "Sır Açığı"},
    {"text": "Sır Akması"},
    {"text": "Sır bekleme süresi"},
    {"text": "Sır Deliği"},
    {"text": "Sır Gramajı"},
    {"text": "Sır Gramajı Standardı Eksikliği"},
    {"text": "Sır Kalınlığı"},
    {"text": "Sır Karışması"},
    {"text": "Sır Kazan Temizliği"},
    {"text": "Sır kazanına düşen ürünlerin alınmaması"},
    {"text": "Sır Transferi Yapılırken Elek Kullanılmaması"},
    {"text": "Sır Yırtılması"},
    {"text": "Sırlama Saati"},
    {"text": "Silim Suyu"},
    {"text": "Silim Süngeri"},
    {"text": "Spot İzi"},
    {"text": "Standart Dışı Üretim"},
    {"text": "Su Emme-Porozite Değeri"},
    {"text": "Su İzi"},
    {"text": "Sucuk Sertlik Değeri"},
    {"text": "Taban Çatlağı"},
    {"text": "Tahta Silimi"},
    {"text": "Talimat/Prosedür Eksikliği"},
    {"text": "Tank karışması"},
    {"text": "Taşlama Su Ayarı"},
    {"text": "Teknik İşler Uygunsuzluğu"},
    {"text": "Temizlik"},
    {"text": "Tiksotropi"},
    {"text": "Tozlu Ürün"},
    {"text": "Uygulama Hatası"},
    {"text": "Uygun olmayan programda üretim"},
    {"text": "Uygunsuz Maşa Seçimi"},
    {"text": "Ürün bekleme süresi"},
    {"text": "Ürün Kimlik Kartı Uygunsuzluğu"},
    {"text": "Vantuz Çatlağı"},
    {"text": "Vantuz İzi"},
    {"text": "Vardiya Teslim"},
    {"text": "Viskozite"},
    {"text": "Vurdurma"},
    {"text": "Yağ Lekesi"},
    {"text": "Yanlış Ekipman Seçimi"},
    {"text": "Yırtık Zımpara"},
    {"text": "Yoğunluk Değeri"},
    {"text": "Zımpara Temizliği"}
]



export const SekillendirmeData=[
    "IzoStatikPresData", 
    "OtomatikTorna", 
    "ManDikTorna", 
    "YuksekBasinc", 
    "DokumHatti", 
    "KulpDokum"
]




export const HammaddeData=[

    "Astarlama", 
    "YuksekBasinc", 
    "DokumHatti", 
    "GranulKontrol", 
    "GranulTaneKontrol",
    "KulpDokum"
]


